module.exports = __webpack_public_path__ + "img/icon-teacher-2.0ed92e3.png";